import { PureComponent } from 'react';
import { string } from 'prop-types';

import { disableScroll, enableScroll } from 'utils/disableScroll';

class DisableScroll extends PureComponent {
    static propTypes = {
        allowScrollOn: string.isRequired,
    };

    componentDidMount() {
        this.oldPosition = document.body.style.position;
        this.scrollTop = window.scrollY;
        disableScroll(this.props.allowScrollOn, {
            ignoredTargets: ['.mobile-filter-container__children *'],
        });
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.marginTop = `-${this.scrollTop}px`;
    }

    componentWillUnmount() {
        enableScroll(this.props.allowScrollOn);
        document.body.style.position = this.oldPosition;
        document.body.style.marginTop = 0;
        window.scrollTo(0, this.scrollTop);
        this.scrollTop = null;
    }

    render() {
        return null;
    }
}

export default DisableScroll;
